import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
const headers = (token) => ({ headers: { 'x-auth-token': token } });

export async function createAppointment({ token, clientId, conversationId, scheduledStart, scheduledEnd, modality, notes }) {
  const res = await axios.post(
    `${API_BASE_URL}/appointments`,
    { clientId, conversationId, scheduledStart, scheduledEnd, modality, notes },
    headers(token)
  );
  return res.data;
}

export async function listTherapistAppointments({ token, from, to, clientId }) {
  const params = new URLSearchParams();
  if (from) params.set('from', from);
  if (to)   params.set('to',   to);
  if (clientId) params.set('clientId', clientId);
  const qs = params.toString();
  const res = await axios.get(
    `${API_BASE_URL}/appointments${qs ? '?' + qs : ''}`,
    headers(token)
  );
  return res.data;
}

export async function listMyAppointments({ token }) {
  const res = await axios.get(
    `${API_BASE_URL}/appointments/me`,
    headers(token)
  );
  return res.data;
}

export async function cancelAppointment({ token, appointmentId, reason }) {
  const res = await axios.post(
    `${API_BASE_URL}/appointments/${appointmentId}/cancel`,
    { reason },
    headers(token)
  );
  return res.data;
}

export async function updateAppointment({ token, appointmentId, scheduledStart, scheduledEnd, notes, status }) {
  const payload = {};
  if (scheduledStart !== undefined) payload.scheduledStart = scheduledStart;
  if (scheduledEnd   !== undefined) payload.scheduledEnd   = scheduledEnd;
  if (notes          !== undefined) payload.notes          = notes;
  if (status         !== undefined) payload.status         = status;
  const res = await axios.patch(
    `${API_BASE_URL}/appointments/${appointmentId}`,
    payload,
    headers(token)
  );
  return res.data;
}
